import { render, staticRenderFns } from "./oftenFlowList.vue?vue&type=template&id=2aa68444&scoped=true&"
import script from "./oftenFlowList.vue?vue&type=script&lang=js&"
export * from "./oftenFlowList.vue?vue&type=script&lang=js&"
import style0 from "./oftenFlowList.vue?vue&type=style&index=0&id=2aa68444&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa68444",
  null
  
)

export default component.exports